import { Text } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useMask } from "@react-input/mask";
import { useTranslation } from "react-i18next";

import { TextInput } from "components";
import { MASK_SWISS_PHONE_NUMBER } from "constant/app";

interface PhoneNumberInputProps<T> {
  form: UseFormReturnType<T>;
  fieldName: keyof T | string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
}

export const PhoneNumberInput = <T,>({
  form,
  fieldName,
  label,
  disabled = false,
  required = false,
}: PhoneNumberInputProps<T>) => {
  const { t } = useTranslation();

  const phoneNumberRef = useMask({
    mask: MASK_SWISS_PHONE_NUMBER,
    replacement: { _: /\d/ },
  });

  return (
    <TextInput
      label={label ?? t("user.phoneNumber.label")}
      key={form.key(fieldName as string)}
      {...form.getInputProps(fieldName)}
      ref={phoneNumberRef}
      leftSection={<Text size="xs" pt={2}>+41</Text>}
      leftSectionWidth={36}
      required={required}
      disabled={disabled}
    />
  );
};
